"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWithTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LabelWithTooltip = exports.LabelWithTooltip = function LabelWithTooltip(_ref) {
  var label = _ref.label,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/_react["default"].createElement("span", null, label, ' ', /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: tooltip
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))));
};